/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { useDispatch } from "react-redux";
import { login } from "store/slice/user";
import {loginApi} from "api/services/authentication"
// import { resetFunctionwithlogin } from "../../../components/ResetFunction";
import {useAuth} from "context/userContext"
import {Button} from "components/Button"
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("Password is required"),
});

const Login = () => {
  const details = localStorage.getItem("loginDetails");

  const loginData = JSON.parse(details);

  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false)
  const {token, login} = useAuth();


  // const onSubmit = (data) => {
  //   const currentUser = loginData?.find((item) => item?.email === data?.email);
  //   if (!currentUser) {
  //     setEmailError(true); // Email is not registered
  //     navigate("/");
  //   } else if (currentUser.password === data?.password) {
  //     setEmailError(false); // Email is registered, and password is correct
  //     const Value = {
  //       email: data?.email,
  //       password: data?.password,
  //     };
  //     dispatch(login(Value));
  //     localStorage.setItem("credencial", JSON.stringify(Value));
  //     navigate("/admin-dashboard");
  //     resetFunctionwithlogin();
  //   } else {
  //     setEmailError(true); // Email is registered, but the password is incorrect
  //     navigate("/");
  //   }
  // };

  function refreshPage() {
    window.location.reload(false);
  }

  // useEffect(()=>{
  //   if(token){
  //     navigate("/employee-dashboard");
  //   }
  // },[token])
  const onSubmit = (data) => {
    console.log(data, "DDDDD")
    setLoading(true)

    loginApi(data).then(response=>{
      console.log(response.data, "DAAAA")
      login(response.data)
      // console.log(token, "token")
      setLoading(false)



    }).catch(err=>{
      console.log(err.response?.data?.detail)
      setLoading(false)
      setError("root", {
        type: "400",
        message:  err.response?.data?.detail
      })
      // setError("root", err.response?.data?.detail)

    })

  };

  useEffect(() => {
    setValue("email", localStorage.getItem("email"));
    setValue("password", localStorage.getItem("password"));
  }, []);

  const [eye, seteye] = useState(true);

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            {/* <Link to="/job-list" className="btn btn-primary apply-btn">
              Apply Job
            </Link> */}
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/employee-dashboard">
                  <img src={"https://storage.mealtrackr.io/internal/Nandos-Logo.png"} alt="Dreamguy's Technologies" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Login</h3>
                  <p className="account-subtitle">Access to our dashboard</p>
                  {
                    console.log(errors, "LLLL")
                  }
                  {/* Account Form */}
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {
                        errors?.root?.message && 
                        <span className="text-danger">
                          {" "}
                          {errors?.root?.message}{" "}
                        </span>
                      }
                      <div className="input-block mb-4">
                        <label className="col-form-label">Email Address</label>
                        <Controller
                          name="email"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.email ? "error-input" : ""
                              }`}
                              type="text"
                              // defaultValue={localStorage.getItem("email")}
                              onChange={field.onChange}
                              value={field.value}
                              autoComplete="true"
                            />
                          )}
                        />

                        <span className="text-danger">
                          {" "}
                          {errors.email?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label">Password</label>
                          </div>
                          <div className="col-auto">
                            <Link className="text-muted" to="/forgot-password">
                              Forgot password?
                            </Link>
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                              <input
                                className={`form-control ${
                                  errors?.password ? "error-input" : ""
                                }`}
                                type={eye ? "password" : "text"}
                                // defaultValue={localStorage.getItem("password")}
                                value={field.value}
                                onChange={field.onChange}
                                // autoComplete="true"
                              />
                            )}
                          />
                          <span
                            style={{
                              position: "absolute",
                              right: "5%",
                              top: "30%",
                            }}
                            onClick={onEyeClick}
                            className={`fa-solid ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            } `}
                          />
                        </div>
                        <span className="text-danger">
                          {" "}
                          {errors.password?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block text-center">
                        <Button 
                        loading={loading} 
                        disabled={loading} 
                        label="Login" 
                        type="submit" 
                        className="btn btn-primary account-btn"
                         />

                        {/* <button
                          className="btn btn-primary account-btn"
                          type="submit"
                        >
                          Login
                        </button> */}
                      </div>
                    </form>
                    {/* <div className="account-footer">
                      <p>
                        Don't have an account yet?{" "}
                        <Link to="/register">Register</Link>
                      </p>
                    </div> */}
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
